import {
    SET_AUTOMOBILE_MARKETING_PRICE_HISTORY,
    SET_AUTOMOBILE_MARKETING_OFFER_HISTORY,
    SET_AUTOMOBILE_MARKETING_HAS_BROCHURE
} from '../../types';

const initialState = {
    MarketingOfferHistory: [],
    MarketingPriceHistory: [],
    //  DESC: These are environment variables
    AppMarketingURL: process.env.APP_CLIENT === 'FDIC' ? 'http://fdic-ore.com' : 'http://www.usmsrealestate.com',
    hasBrochure: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_AUTOMOBILE_MARKETING_OFFER_HISTORY:
            return {
                ...state,
                MarketingPriceHistory: [...payload]
            };
        case SET_AUTOMOBILE_MARKETING_PRICE_HISTORY:
            return {
                ...state,
                MarketingOfferHistory: [...payload]
            };
        case SET_AUTOMOBILE_MARKETING_HAS_BROCHURE:
            return {
                ...state,
                hasBrochure: payload
            };
        default:
            return state;
    }
}
